export { default as NavBar } from './src/navbar.vue';
